export default "__VITE_ASSET__e56ae1e8__"